export function normalizeDimension(
  value?: number | string,
): number | undefined {
  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    if (isNaN(parsed)) {
      console.error(`Invalid dimension value: ${value}`);
      return undefined;
    }
    return parsed;
  }

  return undefined;
}
